export const isActionIdWorkflow = (actionId?: string) =>
  actionId ? actionId.startsWith('workflow.') : false
